export default __webpack_public_path__ + "82ca35f36c58b73e83df7c206ebd70d5.svg";